<template>

    <div class="hero__content">

        <span class="hero__subtitle uppercase">

            {{'BUILDING THE FUTURE' | i}}

        </span>

        <h1 class="hero__title">

            {{ 'hero' | staticTitle }}

        </h1>

        <p class="hero__description">

            <vue-marked>{{ 'hero' | staticContent }}</vue-marked>

        </p>

    </div>

</template>

<script>
import {langUserSet} from '@/utils.js';

export default {
    name: 'HomeHero',
    methods: {
        langUserSet
    }
};
</script>